import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const UNLOCK_MENU_CURATION_TASK_DISHES_MUTATION = gql`
  mutation unlockMenuCurationTaskDishesMutation($id: ID!) {
    unlockMenuCurationTaskDishes(id: $id) {
      id
      taskStatus
      isTierOneDone
      isUnknownWordsCurationDone
      isUnknownWordsQaDone
      isCurationDone
      isQaDone
      isQcDone
      isAvailableForTierOne
      isAvailableForUnknownWordsCuration
      isAvailableForUnknownWordsQa
      isAvailableForCuration
      isAvailableForQa
      isAvailableForQc
      hasLockedDishes

      assignedCurator {
        ...SimpleUserFragment
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default UNLOCK_MENU_CURATION_TASK_DISHES_MUTATION
